module.exports = __webpack_public_path__ + "static/media/hu.00e7c406.svg";